import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/VolumeLevel3.svg'

export const IconVolumeLevel3 = IconSVG as IconComponent
